import is from '@sindresorhus/is';

import type { SectionTagDefinition } from './job-profile';

type TranslationText = SectionTagDefinition['names'][number];

type SectionNameMap = ReadonlyMap<string, readonly TranslationText[]>;

export const buildSectionNameMap = (
    sectionTags: ReadonlyArray<{ readonly id: string; readonly names: readonly TranslationText[] }> | undefined,
): SectionNameMap | null => {
    if (is.undefined(sectionTags) || is.emptyArray(sectionTags)) {
        return null;
    }
    return new Map(sectionTags.map((st) => [st.id, st.names]));
};

export const resolveSectionTitle = (
    sectionNames: SectionNameMap | null,
    id: string | undefined,
    locale: string,
): string | null => {
    if (is.null(sectionNames) || is.undefined(id)) {
        return null;
    }
    const names = sectionNames.get(id);
    if (is.undefined(names)) {
        return null;
    }
    return names.find((n) => n.locale === locale)?.text ?? null;
};
